import React, { FC } from 'react'
import { Dialog, DialogTitle, IconButton } from '@mui/material'
import { originalIcons } from '@shared/components/icons/icons'
import makeStyles from '@mui/styles/makeStyles'
import { AuditRequirementImage } from '@shared/types'

interface Props {
  currentImagePreview: AuditRequirementImage | null
  isImagePreviewOpen: boolean
  onImagePreviewClose: () => void
}

export const RequirementPhotoDialog: FC<Props> = ({
  currentImagePreview,
  isImagePreviewOpen,
  onImagePreviewClose,
}) => {
  const classes = useStyles()

  return (
    <Dialog
      open={isImagePreviewOpen}
      onClose={onImagePreviewClose}
      maxWidth={false}
    >
      <DialogTitle className={classes.imagePreviewTitle}>
        <IconButton onClick={onImagePreviewClose} size="large">
          <originalIcons.Close />
        </IconButton>
      </DialogTitle>
      {currentImagePreview && (
        <img src={currentImagePreview.imageURL} alt="preview" />
      )}
    </Dialog>
  )
}

export const useStyles = makeStyles({
  imagePreviewTitle: {
    padding: 0,
    display: 'flex',
    flexFlow: 'row-reverse',
  },
})
